import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniVoucherComponent } from './mini-voucher.component';
import { MotesMediaModule } from '../motes-media/motes-media.module';
import { SvgIconModule } from '../svg-icon';
import { LightImageModule } from '../light-image/light-image.module';

@NgModule({
    declarations: [MiniVoucherComponent],
    imports: [
        CommonModule,
        MotesMediaModule,
        SvgIconModule,
        LightImageModule
    ],
    exports: [MiniVoucherComponent]
})
export class MiniVoucherModule { }
